import { HlmBadge } from './lib/hlm-badge';

export * from './lib/hlm-badge';

export const HlmBadgeImports = [HlmBadge] as const;
